import React, { createContext, useContext } from "react"

import "./Teaser.scss"

import { useLayout } from "@Quiz/layout"
import ArrowLink from "@ui/ArrowLink"

interface ITeasersContext {
  teasers: Teaser.Api.Teaser[]
}
export const TeasersContext = createContext<ITeasersContext>({ teasers: [] })
TeasersContext.displayName = "TeasersContext"

export const WithTeasers: React.FC<React.PropsWithChildren<{teasers: Teaser.Api.Teaser[]}>> = ({ children, teasers }) => {
  return <TeasersContext.Provider value={{teasers}}>
    {children}
  </TeasersContext.Provider>
}

const isSet = (val: string | undefined) => val && val.length > 0

export const useTeasers = () => useContext(TeasersContext)

export const TeasersWrapper: React.FC<React.PropsWithChildren> = ({children}) => {
  return <div className="neo__teasers">{children}</div>
}

export const Teaser: React.FC<{teaser: Teaser.Api.Teaser}> = ({teaser}) => {
  const { type } = useLayout()

  let img: Base.Api.ImageUrls | undefined
  if (type === "desktop") {
    img = teaser.image_desktop || teaser.image_mobile || teaser.image
  } else {
    img = teaser.image_mobile || teaser.image_desktop || teaser.image
  }
  return (
    <div className="neo__teaser">
      {img && <div className="neo__teaser__imgHolder"><img src={img["1x"]} /></div>}
      <div className="neo__teaser__content">
        {isSet(teaser.title) && <div className="neo__teaser__title">{teaser.title}</div>}
        {isSet(teaser.headline) && <div className="neo__teaser__headline">{teaser.headline}</div>}
        <div className="neo__teaser__text" dangerouslySetInnerHTML={{__html: teaser.text}} />
        {isSet(teaser.link_text) && isSet(teaser.link_url) &&
          <div className="neo__teaser__linkHolder"><ArrowLink href={teaser.link_url}>{teaser.link_text}</ArrowLink></div>}
      </div>
    </div>
  )
}
